<div class="body-holder">
  <aside class="sidebar">
    <app-document-sidebar-header>
      <a class="btn-M btn-text icon-start" [routerLink]="urlParamsService.params.mainPath || ['/documentos', documentId]">
        <i class="fal fa-chevron-left"></i>
        {{ 'button.back' | translate }}
      </a>
    </app-document-sidebar-header>
    <main class="document-signers">
      <div class="document-signers-top">
        <div class="document-signers-title">{{ 'documents.additionalSettings' | translate }}</div>
      </div>
      <app-document-configs-form
        [(document)]="documentInput"
        [documentCreatedAt]="document.created_at"
        [validationErrors]="validationErrors"
        [isPdfA]="isPdfA"
        *ngIf="documentInput"
        #configsForm
      ></app-document-configs-form>
    </main>
    <footer class="sidebar-options">
      <button type="button" class="sidebar-options-submit" [disabled]="isLoading" (click)="updateDocument()">{{ 'button.save' | translate }}</button>
    </footer>
  </aside>
  <section class="models">
    <div class="monster__tabs" *ngIf="!isMobile && appService.isAutentiqueDomain()">
      <button
        type="button"
        class="tab__item"
        (click)="changeDocumentConfigTab(DocumentAdditionalConfigTab.AdditionalConfigDocument)"
        [ngClass]="{ active: currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigDocument }"
      >
        <i class="fa-regular fa-file-lines"></i>{{ 'settings.document' | translate }}
      </button>
      <button
        type="button"
        class="tab__item"
        (click)="changeDocumentConfigTab(DocumentAdditionalConfigTab.AdditionalConfigEmail)"
        [ngClass]="{ active: currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigEmail }"
      >
        <i class="fa-regular fa-envelope"></i>{{ 'auth.mail' | translate }}
      </button>
      <button
        type="button"
        class="tab__item"
        (click)="changeDocumentConfigTab(DocumentAdditionalConfigTab.AdditionalConfigWhatsapp)"
        [ngClass]="{ active: currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigWhatsapp }"
      >
        <i class="fa-brands fa-whatsapp"></i>{{ 'documents.whatsapp' | translate }}
      </button>
    </div>

    <div [hidden]="currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigDocument">
      @if (!documentService.isMarkdownDocument(document) && !dynamicDocumentViewOptions?.isDynamicDocument) {
        <app-pdf-viewer
          [pdfUrl]="!documentService.isPastLifecycle(document) && document?.files.original"
          [qualified]="document?.qualified"
          [documentFooter]="documentInput?.new_signature_style && documentInput?.footer"
          [documentFooterType]="documentInput?.new_signature_style && documentInput?.footer_type"
          [document]="document"
          [isNewSignatureStyle]="documentInput?.new_signature_style"
          [floatingFields]="floatingFields"
          [documentWhitelabel]="documentWhitelabel"
          [isDocumentWhitelabelLoaded]="isDocumentWhitelabelLoaded"
          [class.d-none]="documentService.isPastLifecycle(document)"
        >
        </app-pdf-viewer>
      }
      @if (documentService.isMarkdownDocument(document)) {
        <app-markdown-handler [markdownUrl]="document?.files.original"> </app-markdown-handler>
      }
      @if (documentService.isPastLifecycle(document)) {
        <app-document-lifecycle-warning [(document)]="document"></app-document-lifecycle-warning>
      }
      @if (dynamicDocumentViewOptions?.isDynamicDocument) {
        <app-dynamic-document-viewer [content]="dynamicDocumentViewOptions.content" [theme]="dynamicDocumentViewOptions.theme"></app-dynamic-document-viewer>
      }
    </div>

    <div class="models__container" [hidden]="currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigEmail">
      <div class="alertMessage size-M default mb-3">
        <i class="fa-regular fa-circle-info"></i>
        <div>
          <span [innerHTML]="'documents.configEmailTemplatesDescription' | translate"></span>
        </div>
      </div>

      <app-document-configs-email
        *ngIf="pageTopTabLoad[DocumentAdditionalConfigTab.AdditionalConfigEmail]"
        [(document)]="documentInput"
        [selectedLang]="(documentInput?.locale?.language || '').replace('-', '')"
        [validationErrors]="validationErrors"
      ></app-document-configs-email>
    </div>

    <div class="models__container" [hidden]="currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigWhatsapp">
      <div class="alertMessage size-M default mb-3">
        <i class="fa-regular fa-circle-info"></i>
        <div>
          <span [innerHTML]="'documents.configWhatsappTemplatesDescription' | translate"></span>
        </div>
      </div>

      <app-document-configs-whatsapp
        *ngIf="pageTopTabLoad[DocumentAdditionalConfigTab.AdditionalConfigWhatsapp]"
        [(document)]="documentInput"
        [selectedLang]="(documentInput?.locale?.language || '').replace('-', '')"
      ></app-document-configs-whatsapp>
    </div>
  </section>
</div>
